export default {
    required: 'Field is require',
    email: 'Invalid email format',
}